import { connect } from 'react-redux'
import {
  selectCurrentOptions,
  selectStagedOptions,
  selectInitialChanges,
  resetStagedOptions,
  selectSaveOptionsError,
  selectSaveOptionsStatus,
} from '../resource_options_slice.js'
import { saveOptions } from '../actions/ClientActions.js'
import UnsavedChanges from '../components/UnsavedChanges.tsx'

const mapStateToProps = (state, props) => {
  const { resourceId, resourceType } = props
  const currentOptions = selectCurrentOptions(state, resourceType, resourceId)
  const stagedOptions = selectStagedOptions(state, resourceType, resourceId)
  const initialChanges = selectInitialChanges(state, resourceType, resourceId)

  const status = selectSaveOptionsStatus(state, resourceType, resourceId)
  const error = selectSaveOptionsError(state, resourceType, resourceId)

  return {
    currentOptions,
    stagedOptions,
    initialChanges,
    status,
    error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSave: (resourceType, resourceId, stagedOptions) => {
      dispatch(saveOptions({ resourceId, resourceType, options: stagedOptions }))
    },
    onReset: (resourceType, resourceId) => {
      dispatch(resetStagedOptions({ resourceId, resourceType }))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnsavedChanges)
